import { keyframes } from "@emotion/react"
import FilledInput from "@mui/material/FilledInput"
import FormControl from "@mui/material/FormControl"
import Icon from "@mui/material/Icon"
import IconButton from "@mui/material/IconButton"
import InputLabel from "@mui/material/InputLabel"
import { useState } from "preact/hooks"
import { IconAnimationInDeciseconds } from "./experiments"
import type { TitleFieldInputProps } from "./TitleFieldInputProps"

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`

export function AdornedInput({
  hasValidationError,
  innerValue,
  inputRef,
  isSubmitting,
  label,
  onSubmit,
  placeholder,
  setHasValidationError,
  setInnerValue,
  submitIfValid,
}: TitleFieldInputProps & {
  isSubmitting: boolean
}) {
  const [showAdornment, setShowAdornment] = useState<boolean>(false)
  return (
    <FormControl sx={{ flexGrow: 1, flexShrink: 1 }} variant="filled">
      <InputLabel
        sx={{ width: "100%" }}
        htmlFor="the-title"
        children={label}
        shrink
      />
      <FilledInput
        id="the-title"
        disabled={!onSubmit}
        placeholder={placeholder}
        error={hasValidationError}
        sx={{ width: "100%" }}
        onChange={(event: any) => {
          setInnerValue(event.target.value)
          setHasValidationError(false)
        }}
        value={innerValue}
        inputRef={inputRef as any}
        onFocus={() => setShowAdornment(true)}
        onBlur={() => {
          setShowAdornment(false)
          submitIfValid()
        }}
        endAdornment={
          (showAdornment || isSubmitting) && (
            <IconButton
              color="primary"
              aria-label="create or update poll"
              onClick={submitIfValid}
              onMouseDown={(event: any) => event.preventDefault()}
              edge="end"
            >
              <Icon
                children="cached"
                sx={{
                  animation: isSubmitting
                    ? `${rotation} ${
                        IconAnimationInDeciseconds / 10
                      }s linear infinite`
                    : "",
                }}
              />
            </IconButton>
          )
        }
      />
    </FormControl>
  )
}
